import React, { useState } from 'react';
import { Container, Box, Typography, AppBar, Toolbar, Tabs, Tab } from '@mui/material';
import {
	FileText, History, BarChart2, BarChart, BookOpen, LineChart, Settings
} from 'lucide-react';
// import BusinessSelector from './components/BusinessSelector';
import LedgerView from './LedgerView';
import TransactionTracker from './TransactionTracker';
import AllLedgers from './AllLedgers';

export default function Transactions() {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const renderContent = () => {
		switch (activeTab) {
			case 0:
				return <LedgerView />;
			case 1:
				return <TransactionTracker />;
			case 2:
				return <AllLedgers />;
			case 3:
				return <Typography variant="h5" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>Reconciliation View</Typography>;
			case 4:
				return <Typography variant="h5" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>Analytics & Reports View</Typography>;
			case 5:
				return <Typography variant="h5" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>Performance Metrics View</Typography>;
			case 6:
				return <Typography variant="h5" sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>Settings View</Typography>;
			default:
				return <TransactionTracker />;
		}
	};

	return (
		<Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
			<AppBar
				position="sticky"
				sx={{
					bgcolor: 'white',
					boxShadow: 'none',
					borderBottom: '1px solid',
					borderColor: 'grey.200'
				}}
			>
				<Toolbar>
					<Container>
						<Box sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%'
						}}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
								<Typography
									variant="h6"
									component="h1"
									sx={{
										fontWeight: 600,
										color: '#0f172a',
										letterSpacing: '-0.025em'
									}}
								>
									Transactions
								</Typography>
							</Box>
							{/* <BusinessSelector
								selectedBusiness={selectedBusiness}
								onBusinessChange={setSelectedBusiness}
							/> */}
						</Box>
					</Container>
				</Toolbar>
				<Container maxWidth="xl">
					<Tabs
						value={activeTab}
						onChange={handleTabChange}
						variant="scrollable"
						scrollButtons="auto"
						sx={{
							'& .MuiTab-root': {
								textTransform: 'none',
								minHeight: 48,
								fontSize: '0.875rem',
							}
						}}
					>
						<Tab
							icon={<BarChart2 className="w-4 h-4 mr-2" />}
							label="Summary Dashboard"
							iconPosition="start"
						/>
						<Tab
							icon={<History className="w-4 h-4 mr-2" />}
							label="Transaction Tracker"
							iconPosition="start"
						/>
						<Tab
							icon={<BookOpen className="w-4 h-4 mr-2" />}
							label="All Ledgers"
							iconPosition="start"
						/>
						<Tab
							icon={<FileText className="w-4 h-4 mr-2" />}
							label="Reconciliation"
							iconPosition="start"
						/>
						<Tab
							icon={<BarChart className="w-4 h-4 mr-2" />}
							label="Analytics & Reports"
							iconPosition="start"
						/>
						<Tab
							icon={<LineChart className="w-4 h-4 mr-2" />}
							label="Performance Metrics"
							iconPosition="start"
						/>
						<Tab
							icon={<Settings className="w-4 h-4 mr-2" />}
							label="Settings"
							iconPosition="start"
						/>
					</Tabs>
				</Container>
			</AppBar>

			<Container maxWidth="xl" sx={{ py: 4 }}>
				{renderContent()}
			</Container>
		</Box>
	);
}
